import { render, staticRenderFns } from "./ContractModifyApprovalDate.vue?vue&type=template&id=97637b22"
import script from "./ContractModifyApprovalDate.vue?vue&type=script&lang=js"
export * from "./ContractModifyApprovalDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports